// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2T74r","notes":"Notes_notes__W2yx6","note":"Notes_note__zy5jX","markdown":"Notes_markdown__IDk7J"};